import { i18n } from '../i18n'

export default {
  path: '/programs',
  name: 'Programs',
  component: () => import(/* webpackChunkName: 'programs' */ '../views/Programs/Programs.vue'),
  children: [
    {
      path: '',
      name: 'ProgramList',
      component: () => import(/* webpackChunkName: 'programs-table' */ '../views/Programs/ProgramsTable.vue'),
      meta: {
        title: i18n.global.t('default.programs.title') + ' | UG',
        requiresAuth: true,
        uri:'/programs'
      }
    },
    {
      path: '/subject-management/:programID/:moduleID?',
      name: 'Subject Management',
      component: () => import(/* webpackChunkName: 'programs-table' */ '../views/Programs/SubjectManagement.vue'),
      meta: {
        title: i18n.global.t('default.programs.title') + ' | UG',
        requiresAuth: true,
         uri:'/programs'
      }
    },
    {
      path: ':id',
      name: 'ProgramDetails',
      component: () => import(/* webpackChunkName: 'program-details' */ '../views/Programs/Details.vue'),
      meta: {
        title: i18n.global.t('default.programs.details') + ' - ' + i18n.global.t('default.programs.details.title') + ' | UG',
        requiresAuth: true,
         uri:'/programs'
      }
    }
  ]
}
